import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { notification } from "antd";
import { getCronConfig, updateCronConfig, reset } from './redux/slice';
import moment from 'moment';

const SECOND = 1000 //1 second = 10000ms
const MINUTE = SECOND * 60
export const CronConfig = () => {

    const dispatch = useDispatch();
    const { messages } = useIntl();

    const { data, result, error, loading } = useSelector(state => state.cronConfigRedux)

    const [values, setValues] = useState({
        cronCampaigns: MINUTE
    })
    
    useEffect(() => {
        dispatch(getCronConfig())
    }, [])

    useEffect(() => {
        if(data){
            setValues({
                cronCampaigns: data?.cronCampaigns?.interval || MINUTE
            })
        }
    }, [data])

    useEffect(() => {
        if (result) {
            dispatch(reset({ result: null }));
            notification.success({ message: messages["saveSuccessfully"] });
        }

        if (error) {
            dispatch(reset({ error: null }));
            notification.error({
                message: messages["saveError"],
                description: messages[error] || error,
            });
        }
    }, [ result, error])
    
    const handleError = (key) => (e) => {
        let value = parseInt(e.target.value, 10);
        if (isNaN(value)) value = MINUTE;
        if (value < MINUTE) value = MINUTE;
        if (value % MINUTE !== 0) value = Math.round(value / MINUTE) * MINUTE;
        setValues((prev) => ({
            ...prev,
            [key]: value
        }));
    }

    const onSave = (key) => () => {
        if(data && data['cronCampaigns'].miliseconds != values['cronCampaigns']){
            dispatch(updateCronConfig({cronName: key, value: values['cronCampaigns']}))
        }
    }

    return (
        <div className="row">
            <div className="col-xl-6 col-12">
                <div className="mb-4">
                    <h5 className="card-header">{messages['cronConfig_announcement']?.toString()}</h5>
                    <div className="card-body">
                        <p className="card-text">Ultima esecuzione di cron: {data && data['cronCampaigns'] && data['cronCampaigns']?.lastExecution ? moment(data['cronCampaigns']?.lastExecution).format('dd-mm-YYYY h:m') : 'Non ancora registrato'}</p>
                        <div>
                            <label className="form-label">{messages['cronConfig_interval']?.toString()}</label>
                            <input
                                type="number"
                                className="form-control"
                                min={MINUTE}
                                max={MINUTE * 59}
                                step={MINUTE}
                                onChange={handleError('cronCampaigns')}
                                value={values.cronCampaigns}
                            />
                        </div>
                        <div className="block-ui-btn demo-inline-spacing">
                            <button disabled={loading} onClick={onSave('cronCampaigns')}className="btn btn-primary me-4">{messages['save']?.toString()}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}       
